import React, {useState} from "react";
import {
  CCol,
  CFormGroup,
  CInputGroup,
  CInputGroupAppend,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel
} from "@coreui/react";
import classNames from "classnames";
import ValidationFeedback from "../../ValidationFeedback";

const ARLabel = (
  {
    id,
    labelText,
    prependText,
    appendText,
    groupClassName,
    labelColClassName,
    children
  }
) => {
  const [error, setError] = useState(null);

  return (
    <CFormGroup row>
      <CCol md="3" className={classNames("form-label-col", labelColClassName)}>
        <CLabel htmlFor={id || ""} className="form-label">
          {labelText}
        </CLabel>
      </CCol>
      <CCol xs="12" md="9">
        <CInputGroup className={classNames(groupClassName)}>
          {!!prependText &&
          <CInputGroupPrepend>
            <CInputGroupText>
              {prependText}
            </CInputGroupText>
          </CInputGroupPrepend>
          }
          {React.isValidElement(children) && React.cloneElement(children, {setError})}
          {!!appendText &&
          <CInputGroupAppend>
            <CInputGroupText>
              {appendText}
            </CInputGroupText>
          </CInputGroupAppend>
          }
        </CInputGroup>
        <ValidationFeedback error={error}/>
      </CCol>
    </CFormGroup>
  );
};

export default ARLabel;